import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/content";

export default function Contact() {
  return (
    <div className="pt-28" data-testid="contact-page">
      <section className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.24em] text-gold mb-4">Contact</p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-moss max-w-4xl">
            We'd love to <span className="italic text-gold">hear</span> from you.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-muted leading-relaxed">
            Questions about an order, an ingredient, or which butter is right for your skin — write to us anytime. We
            read every note and answer personally.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 sm:px-8 pb-24 grid gap-6 md:grid-cols-2">
        <Reveal>
          <a
            href={`mailto:${CONTACT.email}`}
            className="block h-full rounded-sm border border-[#E4DDD0] bg-cream p-10 transition-colors hover:border-gold"
            data-testid="contact-email"
          >
            <Mail className="h-7 w-7 text-gold" />
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-gold">Email us</p>
            <p className="mt-3 font-serif text-2xl sm:text-3xl text-moss break-all">{CONTACT.email}</p>
            <p className="mt-3 text-sm text-muted leading-relaxed">Fastest way to reach us — tap to open your mail app.</p>
          </a>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="h-full rounded-sm border border-[#E4DDD0] bg-cream p-10" data-testid="contact-address">
            <MapPin className="h-7 w-7 text-gold" />
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-gold">Our studio</p>
            <p className="mt-3 font-serif text-2xl sm:text-3xl text-moss leading-snug">{CONTACT.address}</p>
            <p className="mt-3 text-sm text-muted leading-relaxed">Where every batch is whipped and poured.</p>
          </div>
        </Reveal>
      </section>

      <section className="bg-cream-2 py-20">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl text-moss">Looking for quick answers?</h2>
            <Link
              to="/faq"
              className="btn-gold mt-6 inline-flex items-center gap-2 rounded-sm px-8 py-4 text-sm font-semibold uppercase tracking-wider"
              data-testid="contact-faq-cta"
            >
              Visit the FAQ <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
